<template>
  <div class="transparent_control_panel"
    @mouseover="mouseEnter"
    @mouseout="mouseOut"
    @mouseup="mouseUp"
    @mousedown="mouseDown"
    @mousemove="mouseMove"
    :style="position"
    >
    <div class="expanded-Area">
      <div class="close-btn" @click="close">
        <svg-icon :icon="cancel" :width="12" :height="12"></svg-icon>
      </div>
      <slot></slot>
    </div>
    <div :class="{
      'transparent_control_panel__non_expanded_area': !showExpand,
      'transparent_control_panel__no-display': showExpand
      }">
    </div>
  </div>
</template>

<script>
import SvgIcon from '@/components/common/svgIcon'
import cancel from '@/assets/svg/cancel.svg'
import { SHOW_TARGET_HISTORY_PANEL } from '@/views/workbenchCanvas/store/WorkbenchWCanvasSlotActionsGenerator'
export default {
  components: {
    SvgIcon
  },
  props: {
    minHeight: {
      type: Number,
      default: 200
    },
    minWidth: {
      type: Number,
      default: 200
    },
    maxHeight: {
      type: Number,
      default: 700
    },
    maxWidth: {
      type: Number,
      default: 700
    },
    initialPosition: {
      type: Object,
      default: {
        top: 50,
        left: 50
      }
    }
  },
  data: () => {
    return {
      cancel,
      isEntered: false,
      showExpand: true,
      draggable: false,
      draggableArea: null,
      positionArea: {},
      // in Milliseconds
      TIME_FOR_ENTER: 200
    }
  },
  computed: {
    canExpand () {
      return this.isEntered
    },
    position () {
      if (this.positionArea) {
        return {
          top: this.positionArea.top + 'px',
          left: this.positionArea.left + 'px'
        }
      }
    }
  },
  mounted () {
    this.positionArea = this.initialPosition
    window.addEventListener('mousemove', this.anyMouseMove)
  },
  destroyed () {
    window.removeEventListener('mousemove', this.anyMouseMove)
  },
  methods: {
    anyMouseMove (e) {
      if (this.draggable) {
        this.reposition(e)
      }
    },
    mouseUp (e) {
      this.draggable = false
      this.draggableArea = null
    },
    mouseDown (e) {
      this.draggable = true
      this.draggableArea = null
    },
    mouseMove (e) {
      if (this.draggable) {
        if (!this.draggableArea) {
          const currentLocation = this.$el.getBoundingClientRect()
          this.draggableArea = {
            left: currentLocation.x,
            top: currentLocation.y,
            startLeft: e.clientX,
            startTop: e.clientY,
          }
        }
        this.reposition(e)
      }
    },
    reposition (e) {
      if (this.draggableArea) {
        const d = this.draggableArea
        this.positionArea = {
          top: d.top + (e.clientY - d.startTop),
          left: d.left + (e.clientX - d.startLeft)
        }
      }
    },
    mouseEnter (e) {
      this.isEntered = true
      setTimeout(() => {
        if (this.canExpand) {
          this.expand()
        }
      }, this.TIME_FOR_ENTER)
    },
    mouseOut (e) {
      if (this.draggable) {
        this.reposition(e)
      } else {
        this.draggableArea = null
      }
      this.isEntered = false
    },
    expand () {
      this.showExpand = true
    },
    close () {
      this.$store.dispatch(SHOW_TARGET_HISTORY_PANEL, false)
    }
  }
}
</script>

<style lang="scss">

.transparent_control_panel {
  position: fixed;
  right: 60px;
  @if ($z-transparent-control-panel) {
    z-index: $z-transparent-control-panel;
  } @else {
    z-index: 200;
  }
  display: inline-block;

  &__non_expanded_area {
    width: 50px;
    height: 50px;
    background-color: rgba(15, 15, 15, .5);
  }

  &__no-display {
    display: none;
  }

}

.expanded-Area {
  width: 600px;
  height: 600px;
  color: white;
  background-color: rgba(15, 15, 15, .8);

    .close-btn {
      height: 34px;
      float: right;
      margin: 11px 11px 0 0;
      cursor: pointer;

      svg {
        fill: white;
      }
    }

}
</style>



// WEBPACK FOOTER //
// TransparentControlPanel.vue?362ed461